/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, ViewChild, OnDestroy, NgZone } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationService } from './registration.service';
import { CommonService } from '../../../shared/services/common.service';
import { COMMON_UMS, REGISTRATION_UMS } from '../../../config/userMessages_en';
import { REG_EXP_LIST } from '../../../config/constants';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
  providers: [RegistrationService]
})
export class RegistrationComponent implements OnInit, OnDestroy {
  @ViewChild('registrationForm') lregistrationFormoginForm!: NgForm;
  public registration: any = { userName: '' };
  public newUser = true;
  public validPassword = false;
  public validConfirmPassword = false;
  public onloadFlag = true;
  public onloadConfirmFlag = true;
  private sub: any;
  private registrationId: any;
  private userObj: any;
  public isLinkActive = true;
  public isReActivationLinkUsed = false;

  constructor(private route: ActivatedRoute,
    private registrationService: RegistrationService,
    private commonService: CommonService,
    private toastr: ToastrService,
    private zone: NgZone,
    private router: Router,
    private translate:TranslateService) { }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  ngOnInit() {
    this.translate.use('en_us');
    this.sub = this.route.params.subscribe(params => {
      if (window.location.href.match('registration')) {
        this.newUser = true;
      } else {
        this.newUser = false;
      }
      this.registrationId = params['id'];
      this.getUserDetails();
      // Fix for error message popup issue in registration page.
      // Setting removing unAuthorizedURL to show error message.
      const lastUnauthorizedUrl = localStorage.getItem('unAuthorizedURL');
        if (lastUnauthorizedUrl && lastUnauthorizedUrl != 'null') {
          localStorage.removeItem('unAuthorizedURL');
      }
    });
  }

  private getUserDetails() {
    if (this.newUser) {
      this.registrationService.authenticateLoginDetails(this.registrationId)
        .then(this.authenticateLoginDetailsSH.bind(this), this.authenticateLoginDetailsFH.bind(this));
    } else {
      this.registrationService.authenticateResetLoginDetails(this.registrationId)
        .then(this.authenticateLoginDetailsSH.bind(this), this.authenticateResetLoginDetailsFH.bind(this));
    }
  }

  // private authenticateResetLoginDetailsSH(response) {
  //   const responseMsg = response;
  //   if (responseMsg) {
  //     this.userObj = responseMsg;
  //     this.registration.userName = responseMsg.emailId;
  //   }
  // }

  private authenticateResetLoginDetailsFH(reason: any) {
    this.isReActivationLinkUsed = true;
    this.commonService.commonErrorHandler(reason);
  }

  private authenticateLoginDetailsSH(response: any) {
    const responseMsg = response;
    if (responseMsg) {
      this.userObj = responseMsg;
      this.registration.userName = responseMsg.emailId;
      this.registration.length = responseMsg.length;
    }
  }

  private authenticateLoginDetailsFH(reason: any) {
    this.isLinkActive = false;
  }

  private getUserDetailsFH(reason: any) {
    this.isLinkActive = false;
    this.commonService.commonErrorHandler(reason);
  }

  public registerPasswordDetails() {
    if (this.userObj) {
      const userObj = this.userObj;
      userObj.password = btoa(this.registration.password);
      this.registrationService.saveRegistrationDetails(userObj)
        .then(this.geRegistrationDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }
  }

  private geRegistrationDetailsSH(response: any) {
    const responseMsg = response;
    this.toastr.success(REGISTRATION_UMS.registration_password_set, COMMON_UMS.SUCCESS);
    if (responseMsg) {
      setTimeout(() => { this.zone.run(() => {this.router.navigateByUrl('/login');}); }, 1000);
    }
  }

  public analyzePassword(reg: any) {
    if (reg.password) {
       const passwordRegex = (reg.length && reg.length === 16)? new RegExp(REG_EXP_LIST.administratorPassword) : new RegExp(REG_EXP_LIST.defaultPassword);
      this.validPassword = passwordRegex.test(reg.password);
      this.onloadFlag = this.validPassword;
    } else {
      this.validPassword = true;
      this.onloadFlag = false;
    }
    if (reg.confirmPassword) {
      this.analyzeConfirmPassword(reg, null);
    }
  }

  public analyzeConfirmPassword(reg: any, evt: any) {
    setTimeout(() => {
      if (reg.confirmPassword) {
        this.validConfirmPassword = (evt === reg.password);
      }
      this.onloadConfirmFlag = false;
    }, 0)
  }

  public navigateToLogin() {
    this.zone.run(() => {
      this.router.navigateByUrl('/login');
    });
  }
}
